import { ContractReportQueryDto } from "../../../autogen/bff-api";

export type ContractListFilters = {
  q: ContractReportQueryDto;
  sortBy?: string;
  sortDirection?: string;
  sortByCustomField?: string;
};

const isActiveFilterValue = (value: unknown): boolean => {
  if (value === undefined || value === null) return false;
  if (typeof value === "string") return value.trim() !== "";
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "number") return true;
  if (typeof value === "boolean") return value === true;
  return true;
};

export const hasActiveContractFilters = (filters: ContractListFilters): boolean => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { owningOrganizationId, limit, skip, ...otherFilters } = filters.q;
  const queryActive = Object.values(otherFilters).some(isActiveFilterValue);
  const sortingActive = !!filters.sortBy || !!filters.sortByCustomField || !!filters.sortDirection;
  const paginationActive = typeof skip === "number" && skip > 0;
  return queryActive || sortingActive || paginationActive;
};
